/**
 * Vivlico design-system entry. Importing this module registers every `viv-*`
 * web component, injects the token + component styles, and installs the legacy
 * `window.VivDesignSystem` builder API for not-yet-migrated call sites.
 *
 * Built standalone to `dist/client/shared/vivDesignSystem.js` (see vite.config)
 * and also tree-shaken into the registration bundle via `import '@/components'`.
 */
import tokensCss from '../design/tokens.css?inline';
import componentCss from './styles.css?inline';
import { ensureDesignSystemStyles } from './base.js';
import { registerVivButton } from './VivButton.js';
import { registerVivChip } from './VivChip.js';
import { registerVivField } from './VivField.js';
import { registerVivModal } from './VivModal.js';
import { registerVivSearchResults } from './VivSearchResults.js';
import { buildChip, buildSearchResultButton, buildSearchResultsEmpty, cssClasses, CLASS } from './legacyBuilders.js';
import { installCoreGlobals } from '../core/index.js';

export * from './legacyBuilders.js';
export { VivButton } from './VivButton.js';
export { VivChip } from './VivChip.js';
export { VivField } from './VivField.js';
export { VivModal } from './VivModal.js';
export { VivSearchResults } from './VivSearchResults.js';

let installed = false;

/** Registers all components + styles + globals. Safe to call multiple times. */
export function installDesignSystem(): void {
    if (installed) return;
    installed = true;
    ensureDesignSystemStyles(`${tokensCss}\n${componentCss}`);
    registerVivButton();
    registerVivChip();
    registerVivField();
    registerVivModal();
    registerVivSearchResults();

    installCoreGlobals();
    const target = globalThis as Record<string, unknown>;
    if (!target.VivDesignSystem) {
        target.VivDesignSystem = {
            CLASS,
            cssClasses,
            buildSearchResultsEmpty,
            buildSearchResultButton,
            buildChip,
        };
    }
}

installDesignSystem();
